export default "__VITE_ASSET__FunqvpX___"